import RunConfigService from './runConfigService.js';

/**
 *
 * BrowserDetection object is immediately executed when the page loads.
 * This Object is used to detect the browser and version the user is using.
 *
 * @namespace MarketSiteRegions
 */
class MarketSiteRegions {
    constructor() {

    }

    getMarketSiteRegionData(isGlobalLanding) {
        if (isGlobalLanding) {
            this.REGIONS_SERVICE_URL = RunConfigService.getBaseUrl() + "/apps/hello/services/regions.globallanding.json";
        } else {
            this.REGIONS_SERVICE_URL = RunConfigService.getBaseUrl() + "/apps/hello/services/regions.json";
        }
        let deferred = $.Deferred();
        $.ajax({
            type: "GET",
            url: this.REGIONS_SERVICE_URL,
            contentType: "application/json",
            success: data => {
                deferred.resolve(data);
            },
            error: xhr => {
                deferred.reject(xhr);
            }
        });

        return deferred.promise();
    }
}

export default new MarketSiteRegions();



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/node_modules/@nuskin/ns-util/src/MarketSiteRegions.js
// module id = 185
// module chunks = 0